import { createStore, applyMiddleware, Store } from 'redux';  
import rootReducer from './reducer/rootReducer';  
import thunk from 'redux-thunk';

let store: Store;

export default function configureStore() {  
	if (!store) {
		store = createStore(rootReducer, applyMiddleware(thunk))
	}
	return store
}